import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const inventoriesTypes = {
    inventory: "inventory",
    // item_threshold: "inventory/item_threshold"
    relocateThreshold: "inventory/relocate_threshold",
    reorderThreshold: "inventory/reorder_threshold",
}

export const targetTypes = {
    inventory: "inventory"
}

export const dataTypes = {
    groupSlot: "group_slot",
    groupSlotBatch: "group_slot_batch"
}

export function useInventories({
    inventoriesType: _inventoriesType,
    targetType: _targetType
}) {

    const [inventoriesType, setInventoriesType] = useState(_inventoriesType)
    const [targetType, setTargetType] = useState(_targetType)

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "inventories";
    // const endpoint2 = "item";
    // const endpoint3 = "item/product";

    const list = async (props) => {

        setIsLoading(true);

        try {

            let url = getListsUrl(`${endpoint}/${inventoriesType}`, props);

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        list,
    }

}